import { GREY_COLORS } from '@config/theme/colors'
import { Divider, Stack, styled, Typography } from '@mui/material'
import { useCertificationApi } from '@services/api/certification.api'
import { useQuery } from '@tanstack/react-query'
import { FormattedMessage, useIntl } from 'react-intl'
import ExpiringCertificationCard from './ExpiringCertificationCard'

/**
 * Certifications
 * @constructor
 */
const ExpiringCertifications = () => {
	const { getExpiringCertifications } = useCertificationApi()
	const { formatMessage } = useIntl()

	const { data: expiringCertifications, refetch: expiringCertificationsRefetch } = useQuery({
		queryKey: ['getExpiringCertifications'],
		queryFn: getExpiringCertifications
	})

	return (
		<Container>
			<Header>
				<FormattedMessage
					id="dashboard.expiringCertifications.title"
					values={{
						a: (text) => <Title>{text}</Title>,
						b: (text) => <Typography key="title" variant="h4">{text}</Typography>,
						c: (text) => <Typography key="subtitle" variant="subtitle2">{text}</Typography>,
						count: expiringCertifications?.length || 0
					}}
				/>
			</Header>
			{/* <Tooltip title={expiringCertifications?.length ? formatMessage({ id: 'dashboard.tooltips.viewTraineeDetails' }) : null} placement="bottom-start" followCursor> */}
			<List>
				{
					expiringCertifications?.length
						? expiringCertifications.map((certification, index) => (
							<Stack key={index}>
								{index !== 0 && <Divider />}
								<ExpiringCertificationCard certification={certification} onDiscardClick={expiringCertificationsRefetch} />
							</Stack>
						))
						: (
							<EmptyState>
								<Typography>
									<FormattedMessage id="dashboard.expiringCertifications.list.noData" />
								</Typography>
							</EmptyState>
						)
				}
			</List>
			{/* </Tooltip> */}
		</Container>
	)
}

const Container = styled(Stack)({
	minHeight: 0,
	rowGap: '16px'
})

const Header = styled(Stack)({
	justifyContent: 'center',
	height: '40px'
})

const List = styled(Stack)({
	border: `1px solid ${GREY_COLORS[100]}`,
	borderRadius: '8px',
	minHeight: 0,
	overflowX: 'scroll',
	scrollbarWidth: 'none',
	msOverflowStyle: 'none',
	'&::-webkit-scrollbar': {
		display: 'none'
	}
})

const Title = styled(Stack)({
	alignItems: 'center',
	columnGap: '8px',
	flexDirection: 'row'
})

const EmptyState = styled(Stack)({
	padding: '16px'
})

export default ExpiringCertifications
